import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";

import storageSession from "redux-persist/lib/storage/session";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

import { togglerReducer } from "../feature/sidebartoggle/sidebarToggleSlice";
import roleReducer from "../feature/user/roleSlice";
import { userReducer } from "../feature/user/userSlice";
import { getCountriesSlice } from "../feature/getCountries/getCountriesSlice";
import recevingDashboardFilterSlice from "../feature/dashboardFilter/receivingDashboardFilterSlice.js";
const rootPersistConfig = {
	key: "root",
	storage,
	stateReconciler: autoMergeLevel2,
};

const userPersistConfig = {
	key: "user",
	storage: storageSession,
};
const togglePersistConfig = {
	key: "toggle",
	storage: storageSession,
};
const rolePersistConfig = {
	key: "role",
	storage: storageSession,
};

const rootReducer = combineReducers({
	toggler: persistReducer(togglePersistConfig, togglerReducer),
	role: persistReducer(rolePersistConfig, roleReducer),
	user: persistReducer(userPersistConfig, userReducer),
	receivingFilter: recevingDashboardFilterSlice,
	[getCountriesSlice.reducerPath]: getCountriesSlice.reducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [PERSIST, FLUSH, REHYDRATE, PAUSE, PURGE, REGISTER],
			},
		}).concat(getCountriesSlice.middleware),
});
